import React from "react";
import PropTypes from "prop-types";
import Image from "./ImageElement";
import "../css/Contact.css";
import ChevronRight from "../svg/ICON_chevronRight_Dark.svg";
import Map from "./Map";

/**
 * Contact component
 */
class Contact extends React.Component {
  static displayName = "Contact";
  static propTypes = {
    className: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Contact";
  }

  /**
   * @override
   */
  render() {
    const contactPage = this.props.currentPage;
    const organization = this.props.stores.page.organization;
    const contact = this.props.stores.page.pages.HomePage.first().contacts();
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__card`}>
          <div className={`${this.className}__card-title`}>Contact</div>
          <div className={`${this.className}__content`}>
            <div className={`${this.className}__card-left`}>
              <div className={`${this.className}__card-text`}>
                <div
                  className={`${this.className}__card-html`}
                  dangerouslySetInnerHTML={{
                    __html: contactPage.Content,
                  }}
                />
              </div>
              <div className={`${this.className}__card-img`}>
                <Image
                  src={contactPage.contactImage()[`${this.props.screen}_src`]}
                  alt="contactImage"
                />
              </div>
            </div>
            <div className={`${this.className}__card-right`}>
              <div className="address">
                PQR BETON
                <br />
                La Ballastière
                <br />
                {organization.streetAddress}
                <br />
                CH-{organization.postalCode} {organization.addressLocality}
              </div>
              <div className="contacts">
                {contact.map((ctc) => (
                  <div key={ctc.ID} className="contact">
                    <div className={`${this.className}__card-title`}>
                      {ctc.ContactType}
                    </div>
                    <p>
                      {ctc.Telephone && (
                        <div
                          style={{
                            marginBottom: "1.5rem",
                          }}
                        >
                          <span
                            style={{
                              marginRight: "2rem",
                            }}
                          >
                            tél.
                          </span>
                          <a href={`tel:${ctc.Telephone}`} className="strong">
                            {ctc.Telephone}
                          </a>
                          <br />
                        </div>
                      )}
                      {ctc.Fax && (
                        <div>
                          <span
                            style={{
                              marginRight: "2rem",
                            }}
                          >
                            fax
                          </span>
                          <a href={`tel:${ctc.Fax}`} className="strong">
                            {ctc.Fax}
                          </a>
                          <br />
                        </div>
                      )}
                    </p>
                  </div>
                ))}
              </div>
              <div className={`${this.className}__links`}>
                <div className={`${this.className}__link`}>
                  <a href={contactPage.NewOfferPage}>
                    Demander une offre
                    <img src={ChevronRight} alt=">" className="icon" />
                  </a>
                </div>
                <div className={`${this.className}__link`}>
                  <a href={contactPage.ContactPage}>
                    Formulaire de contact
                    <img src={ChevronRight} alt=">" className="icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${this.className}__map`}>
          <Map />
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js